<template>
  <div>
    <div class="attachmentList">
      <Row :gutter="4">
        <Col span="4">
          <DatePicker type="month" :placeholder="$t('MCM.extraContributionManagement.extraContributionDate')" v-model="startDate" @on-change="searchStartDate()" :transfer="true" style="width:100%;"></DatePicker>
        </Col>
        <Col span="4">
          <Button type="primary" @click="attachmentListModal = true" v-hasPermission="['operationKpiConfigurationManagement:overtimeManagement:add_attachment']">
            {{$t('MCM.extraContributionManagement.addExtraContributionAttachment')}}
          </Button>
        </Col>
      </Row>
    </div>
    <Modal v-model="attachmentListModal" :title="$t('MCM.extraContributionManagement.addExtraContributionAttachment')" :loading="loading" @on-ok="attachmentListSubmit('attachmentListForm')" @on-cancel="attachmentListReset('attachmentListForm')" :mask-closable="false" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="attachmentListForm" :model="attachmentListForm" :label-width="100" :rules="ruleValidate">
        <!-- 额外贡献年月 -->
        <FormItem :label="$t('MCM.extraContributionManagement.extraContributionDate')" prop="overtimeYearMonth">
          <DatePicker type="month" :placeholder="$t('MCM.extraContributionManagement.pleaseSelectExtraContributionDate')" v-model="attachmentListForm.overtimeYearMonth" @on-change="attachmentListForm.overtimeYearMonth=$event" format="yyyy-MM" style="width:300px;"></DatePicker>
        </FormItem>
        <!-- 附件 -->
        <FormItem :label="$t('MCM.extraContributionManagement.attachment')" prop="enclosure">
          <Upload ref="upload" v-model="attachmentListForm.enclosure" :on-success="uploadSuccess" :on-error="uploadError" multiple :headers='{"userName": userName}' type="drag" :action="actionUrl" style="width:300px;" :show-upload-list="true" :on-remove="handleRemove">
            <div>
              <Icon type="ios-cloud-upload" size="50" style="color: #3399ff"></Icon>
              <p>{{$t('message.uploadFile')}}</p>
            </div>
          </Upload>
        </FormItem>
        <!-- 描述 -->
        <FormItem :label="$t('MCM.extraContributionManagement.description')" prop="remark">
          <Input v-model="attachmentListForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="width:300px;"></Input>
        </FormItem>
      </Form>
    </Modal>
    <table-attachment-list></table-attachment-list>
  </div>
</template>
<script>
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
  import TableAttachmentList from '../overtime_management/TableAttachmentList'

  var tableAttachmentList = TableAttachmentList;
  export default {
    components: {
      TableAttachmentList
    },
    data() {
      // 自定义验证 判断上传文件
      const validateUpload = (rule, value, callback) => {
        if (this.attachmentIDs.length > 0) {
          callback();
        } else {
          callback(new Error(this.$t('MCM.extraContributionManagement.PleaseSelectTheFileToUpload')));
        }
      }
      return {
        userName: getCookie(global.cookieName),
        actionUrl: '',
        attachmentIDs: [],  //附件
        startDate: '',
        loading: true,
        attachmentListModal: false,
        attachmentListForm: {
          overtimeYearMonth: '',
          remark: '',
          enclosure: null
        },
        ruleValidate: {
          overtimeYearMonth: [
            {required: true, message: this.$t('MCM.extraContributionManagement.pleaseSelectExtraContributionDate')}
          ],
          remark: [
            {
              required: false,
              message: this.$t('MCM.extraContributionManagement.pleaseEnterDescription'),
              trigger: 'blur'
            },
            {
              type: 'string',
              max: 10000,
              message: this.$t('MCM.extraContributionManagement.EnterMaximumOfCharacters'),
              trigger: 'blur'
            }
          ],
          enclosure: [
            {required: true, validator: validateUpload, trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
      // 上传附件接口
      this.actionUrl = process.env.API_ROOT + '/sme/file/uploadFileS3';
    },
    methods: {
      /************************查询条件*********************/
      // 按额外贡献年月筛选
      searchStartDate: function () {
        eventBus.$emit('startDate', this.startDate);
        tableAttachmentList.methods.showAll();
      },
      /************************附件****************************/
      // 上传成功
      uploadSuccess(res, file, fileList) {
        this.$Message.success(this.$t('common.uploadSuccess'));
        this.attachmentIDs.push(file.response.id);
      },
      // 上传失败
      uploadError(error, file) {
        this.$Message.error(this.$t('common.uploadFail'));
      },
      // 删除附件
      handleRemove(file, fileList) {
        this.$api.file.deleteAttatchment("id", file.response.id)
          .then(res => {
            this.$Message.success(this.$t('common.deleteSuccess'));
            this.attachmentIDs = [];
            for (var i = 0; i < fileList.length; i++) {
              this.attachmentIDs.push(fileList[i].response.id)
            }
          })
      },
      // 添加
      attachmentListSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            // 添加
            this.$api.kpiOvertimeRecordByYearMonth.insertOrUpdate({
              "overtimeYearMonth": this.attachmentListForm.overtimeYearMonth,
              "attachmentIDs": this.attachmentIDs,
              "remark": this.attachmentListForm.remark
            })
              .then(res => {
                setTimeout(() => {
                  tableAttachmentList.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t('common.addSuccess'));
                  this.$refs.upload.clearFiles();
                  this.attachmentIDs = [];
                  this.attachmentListModal = false;
                }, 1000);
              })
          } else {
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t('common.addFail'));
          }
        });
      },
      // 取消
      attachmentListReset: function (name) {
        this.attachmentListModal = false;
        if (this.attachmentIDs.length > 0) {
          // 删除所有附件
          this.$api.file.deleteByAttachmentIDs({
            "attachmentIDs": this.attachmentIDs
          })
            .then(res => {
              this.$refs.upload.clearFiles();
              this.attachmentIDs = [];
            })
        } else {
          this.$refs.upload.clearFiles();
          this.attachmentIDs = [];
        }
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style scoped>
  .attachmentList {
    width: 100%;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/overtime_management/AddAttachmentList.vue